import React from 'react';
import './offers.scss';

import {IsRole_Admin, IsRole_Manager, IsRole_Operator,IsRole_SalesManager} from '../../globals';
import { useAuth } from  '../../contexts/auth'; 
import { createStore } from 'devextreme-aspnet-data';

import DataGrid, {
    Column,
    Export,
    Popup,
    Form,
    //Button,
    Pager,
    Paging,
    FilterRow,
    HeaderFilter,
    RowDragging,
    Lookup,
    Editing,
    Selection,
    Summary,
    Format,
    Grouping,
    GroupItem,
    TotalItem,
    Toolbar,
    SearchPanel
  } from 'devextreme-react/data-grid';

  import { Button } from 'devextreme-react/button';
  //import {Popup} from 'devextreme-react/popup';
  import { useState, useEffect ,useCallback, useRef } from "react";

  import  {   
    Item
    //,SimpleItem,ButtonItem, Label,ToolbarItem 
  } from 'devextreme-react/form';


  import { formatNumber } from 'devextreme/localization';

  const serviceUrl = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/OffertaDettaglio'
  const debug = process.env.ENTITY_DEBUG;

export default function OfferDetailCustomer(props) {

    //var dataGridRef = React.createRef();
    const dataGrid = useRef(null);

    const filterPayload = { 
        idSuper: props.myKey,
        noHidden: true
    };

    const [tipiArticolo, setTipiArticolo] = useState({});
    const [um, setUm] = useState({});
    const [imposte, setImposte] = useState({});
    //const [value, setNewValue] = useState("");
    const notesEditorOptions = { height: 144 };

    const { user } = useAuth(); 

    const isAdmin=IsRole_Admin();
    //console.log('IsAdmin: ' + isAdmin);

    const isSalesManager=IsRole_SalesManager();
    //console.log('IsSalesManager: ' + isSalesManager);

    useEffect(() => {

        const newServiceUrl = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/TipoArticolo';
        var newUrl =  newServiceUrl + "/GetAction";

        const newServiceUrl2 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/UnitaMisura';
        var newUrl2 =  newServiceUrl2 + "/GetAction";

        const newServiceUrl3 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/Imposta';
        var newUrl3 =  newServiceUrl3 + "/GetAction";

        const fetchData = async () => {
            try {

                const response = await fetch(newUrl);
                const json = await response.json();
                if (debug === 1)
                    console.log(json);
                setTipiArticolo(json);

                const response2 = await fetch(newUrl2);
                const json2 = await response2.json();
                if (debug === 1)
                    console.log(json2);
                setUm(json2);

                const response3 = await fetch(newUrl3);
                const json3 = await response3.json();
                if (debug === 1)
                    console.log(json3);
                setImposte(json3);

            } catch (error) {
                console.log("error", error);
            }
        };
        fetchData();
    }, []);

/*    
    function handleChange() {
        //let value = event.target.value;
        setNewValue('false');
        console.log('Passo');
        props.change('false');
     }
*/
    function customizeText(data) {
        return `Righe: ${data.value}`;
    }

    function customizeData(data) {
        return `Totale Offerta: ${formatNumber(data.value, '###,##0.00')}`;
    }

    function customize1(data) {
        return `Totale: ${formatNumber(data.value, '###,###.00')}`;
    }


    function onInitNewRow(e) {
        //e.data.offertaId = props.data.key;
        e.data.offertaId = props.myKey;
        e.data.tipoRigaId = 3;
        e.component.option("editing.popup.title", "Aggiungi Nota"); 
    };

    function onToolbarPreparing(e) {
        var item = e.toolbarOptions.items.find(item => item.name === "addRowButton"); 
            item.options.icon = "doc";  
            item.options.hint= "Nota";  
            if(!allowModify())
                item.options.visible = false;
    
    };

    const remoteDataSource = createStore({

    key: 'id',
    loadUrl: serviceUrl + '/Find',
    
    onBeforeSend: (method, ajaxOptions) => {
        if (method == "load" ) {           
            var payload = ajaxOptions.data;
            payload.values = JSON.stringify(filterPayload);
            ajaxOptions.data = payload;          
        }  
        ajaxOptions.headers = { Authorization: `Bearer ${user.token}`}   
     ;
    },
    insertUrl: serviceUrl + '/InsertAction',
    updateUrl:serviceUrl + '/UpdateAction',
    deleteUrl: serviceUrl + '/DeleteAction'
    
  });

  function onReorder(e) {
    e.promise = processReorder(e);
  }

  async function processReorder(e) {
    
    const visibleRows = e.component.getVisibleRows();
    const newOrderIndex = visibleRows[e.toIndex].data.orderIndex;

    await remoteDataSource.update(e.itemData.id, { orderIndex: newOrderIndex });
    await e.component.refresh();
  }

    function refreshDataGrid() { 
        dataGrid.current.instance().refresh();
    }

    function isToHide(item) {
        return item && (item.name === 'percSconto' || item.name === 'importoSconto'|| item.name === 'importoUnitario'|| item.name === 'quantità' || item.name === 'importoScontato'|| item.name === 'importoTotale');
      }

    const customizeItem = useCallback((item) => {
        if (isToHide(item)) {
          const dataGridInstance = dataGrid.current.instance()
          const editing = dataGridInstance.option('editing');
          const rowIndex = dataGridInstance.getRowIndexByKey(editing.editRowKey);
          var value = dataGridInstance.cellValue(rowIndex, 'tipoRigaId');
          //nasconde gli altri campi se nota
          if (value === 3)
            item.visible = false;
        }
      }, []);

      function onEditingStart(e) {
        if (e.data.tipoRigaId === 3)
            e.component.option("editing.popup.title", "Nota"); 
        else if (e.data.tipoRigaId === 2)
            e.component.option("editing.popup.title", "Prestazione"); 
        else if (e.data.tipoRigaId === 1)
            e.component.option("editing.popup.title", "Materiale"); 
      };

      function onRowInserting(e) {
        e.data.createBy = user.name;
      };
    
      function onRowUpdating(e) {
        e.newData.updateBy = user.name;
      };


    function allowModify() {
        //se  Marketing (1) o RDO (10) o Persa (4) o Non Processata (5) possono modificarla tutti altrimenti se Completata(11) solo il ruolo admin o salesmanager
        if((props.status === 1 || props.status === 10 || props.status === 4 || props.status === 5 ) || ((isAdmin || isSalesManager) &&  (props.status === 11)))
          return true
        else
          return false     
      };


    return (
        <div>

            <DataGrid id="grid-container"
                dataSource={remoteDataSource}
                showBorders={true}
                columnAutoWidth={true}
                onInitNewRow={onInitNewRow}
                onToolbarPreparing = {onToolbarPreparing}
                onEditingStart={onEditingStart}
                //onRowUpdated={onRowUpdated}
                //ref={ref => dataGridRef = ref}
                ref={dataGrid}
                onRowUpdating={onRowUpdating}
                onRowInserting={onRowInserting}
            >
                <Paging  defaultPageSize={40}/>
                <Pager showPageSizeSelector={true} showInfo={true} />
                <Toolbar>
                    <Item location="after">
                        <Button className="offer-toolbar"
                        icon='refresh'
                        hint='Aggiorna'
                        onClick={refreshDataGrid} 
                        />
                    </Item>
                    <Item name="addRowButton"  />
                    
                </Toolbar>

                <RowDragging
                    allowReordering={true}
                    onReorder={onReorder}
                    dropFeedbackMode="push"
                />

                <HeaderFilter visible={true} />
                <Summary>
                    <TotalItem
                        column="codice"
                        summaryType="count"
                        customizeText={customizeText}
                    />
                    <TotalItem
                    column="importoTotale"
                    summaryType="sum" 
                    customizeText={customizeData}
                    />
                </Summary>
                <Selection mode="single" />
                <Editing
                mode="popup"
                allowUpdating={allowModify}
                allowAdding={allowModify}
                allowDeleting={allowModify}
                useIcons={true}
                >
                    <Popup title="&nbsp;&nbsp;&nbsp;Riga Offerta" showTitle={true} width={640} height={500} />
                    <Form customizeItem={customizeItem}>
                        <Item dataField="tipoRigaId" disabled={false} visible={false} colSpan={2} />
        
                        <Item
                            dataField="descrizione"
                            editorType="dxTextArea"
                            colSpan={2}
                            editorOptions={notesEditorOptions} />
                        <Item dataField="importoUnitario" name ="importoUnitario" caption="PV Unit."/>
                        <Item dataField="quantità" name ="quantità" caption="Q.tà"/>
                        <Item dataField="percSconto" name ="percSconto"/>
                        <Item dataField="importoSconto" name ="importoSconto"/>
                        <Item dataField="importoScontato" name ="importoScontato"/>
                        <Item dataField="importoTotale" name ="importoTotale"/>
                        <Item dataField="nascondiImporti" name ="nascondiImporti" editorType="dxCheckBox"/>
                    </Form>   
                </Editing>
                <Grouping autoExpandAll={true} />
                <Column dataField="id" visible={false}/>
                <Column dataField="offertaId" visible={false}/>
                <Column dataField="tipoRigaId" caption="Tipo" width={120}>
                    <Lookup dataSource={tipiArticolo} valueExpr="id" displayExpr="nome2" />
                </Column>
                <Column dataField="codice" caption="Codice" width={80}/>
                <Column dataField="descrizione" caption="Descrizione" width={400}/>
                <Column dataField="impostaId" caption="IVA" width={60}>
                    <Lookup dataSource={imposte} valueExpr="id" displayExpr="codice" />
                </Column>
                <Column dataField="umid" caption="UM" width={60}>
                    <Lookup dataSource={um} valueExpr="id" displayExpr="codice" />
                </Column>

                <Column dataField="quantità" caption="Q.tà" width={80} allowEditing={false}/>
                <Column dataField="importoUnitario" caption="Prz Unit."  allowEditing={false}>
                    <Format type="fixedPoint" precision={2} />
                </Column>
                <Column dataField="percSconto" caption="% Sconto" >
                    <Format type="fixedPoint" precision={0} />
                </Column>
                <Column dataField="importoSconto" caption="Imp. Sconto" visible={false}>
                    <Format type="fixedPoint" precision={2} />
                </Column>
                <Column dataField="importoScontato" caption="Prz. Scontato" visible={false} allowEditing={false}>
                    <Format type="fixedPoint" precision={2} />
                </Column>
                <Column dataField="importoTotale" caption="Prz. Totale" allowEditing={false}>
                    <Format type="fixedPoint" precision={2} />
                </Column>
                <Column
                    caption=""
                    width={36}
                    cellRender={({ data }) => {
                    if (!data.nascondiImporti) return null;
                    return (
                        <i
                        className="dx-icon-deletetable"
                        style={{ color: "#1222d9ff", fontSize: 18 }}
                        title={`Valori nascosti in stampa`}
                        />
                    );
                    }}
                />


                <Column dataField="updateBy" visible={false}/>
                <Column dataField="createBy" visible={false}/>

                <Column dataField="nascondiImporti" visible={false}/>
            </DataGrid>
        </div>  
    )

};